import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  PostApiMfaValidatecodeMutationRequest,
  PostApiMfaValidatecodeMutationResponse,
  PostApiMfaValidatecode401,
  PostApiMfaValidatecode403,
} from "../../../types/PostApiMfaValidatecode";

export function getPostApiMfaValidatecodeUrl() {
  return `/api/MFA/ValidateCode` as const;
}

/**
 * {@link /api/MFA/ValidateCode}
 */
export async function postApiMfaValidatecode(
  data?: PostApiMfaValidatecodeMutationRequest,
  config: Partial<RequestConfig<PostApiMfaValidatecodeMutationRequest>> & {
    client?: typeof client;
  } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    PostApiMfaValidatecodeMutationResponse,
    ResponseErrorConfig<PostApiMfaValidatecode401 | PostApiMfaValidatecode403>,
    PostApiMfaValidatecodeMutationRequest
  >({
    method: "POST",
    url: getPostApiMfaValidatecodeUrl().toString(),
    data,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}
